import { render, staticRenderFns } from "./DeletePageCategoriesModal.vue?vue&type=template&id=85d4ac68&"
import script from "./DeletePageCategoriesModal.vue?vue&type=script&lang=js&"
export * from "./DeletePageCategoriesModal.vue?vue&type=script&lang=js&"
import style0 from "./DeletePageCategoriesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports